<template>
  <div v-if="project.name">
    <div class="wrapper project project--wrapper" :style="setColour('background-color', project.primaryColour)">
      <div class="wrap">
        <div class="project--meta">
          <h1>{{project.name}}</h1>
          <h2>{{project.company}}</h2>

          <div class="project--intro" v-for="(intro, count) in project.intro" :key="`${count}-intro`">
            <p>{{intro}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper">

      <div class="wrap project project--wrap">

        <div class="col col--content project--content">

          <p class="project--link">
            <a class="link link--dark" :href="project.link" target="_blank" rel="nofollow noreferrer noopener">{{project.shortlink}}</a>
            <span v-if="project.developed_by"> / {{project.developed_by}}</span>
          </p>

          <div class="project--tech" v-if="project.tech">
            <p class="title">Tools &amp; Skills:</p>
            <p>{{project.tech}}</p>
          </div>

          <p class="title">About the project:</p>
          <p v-for="(description, count) in project.description" :key="`${count}-desciprion`">{{description}}</p>

        </div>

        <div class="col col--images project--images" :style="setColour('color', project.primaryColour)">

          <div class="project--images__image">
            <img :src="getImage('thumbnails', project.thumbnail)" :alt="project.name + ' thumbnail'" />
            <p>{{project.name}}.</p>
          </div>
          
          <div class="project--images__image" v-for="image in project.images" :key="image.image">
            <img :src="getImage('portfolio', image.image)" :alt="image.alt" />
            <p v-if="image.caption">{{image.caption}}</p>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import portfolioData from '@/assets/data/portfolio.js';

export default {
  name: 'PortfolioSingle',
  props: ['slug'],
  data() {
    return {
      project: {},
    }
  },
  created() {
    
    let project = portfolioData.find(p => this.slugify(p.name) === this.slug);

    if (project === undefined || project.coming_soon === true) {
      this.$router.push({ path: '/' });
    }

    this.project = project;
  },
  mounted() {
    //
  },
  methods: {
    slugify(name) {
      return name.toLowerCase().replace(/ /g, '-');
    },
    getImage(dir, path) {
      return require(`@/assets/images/${dir}/${path}`);
    },
    setColour(cssProperty, colour) {
      let style = {};
      style[cssProperty] = colour;
      return style;
    }
  }
}
</script>

<style lang="scss">

</style>
